<template>
  <NavigationComponent v-if="$route && !($route.meta.showNavbar === false)" />
  <router-view />
  <div class="loader" v-if="store.loader">
    <div class="loader-box"></div>
  </div>
</template>

<script lang="ts" setup>
import { generalStore } from '@/store';

const store = generalStore();
</script>

<style lang="scss">
@import '@/scss/main.scss';
</style>
